/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesContacts.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Contact Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, December 03, 2018 - 03:35:09 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      12/03/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const ContactList = Loadable({
    loader: () => import('../containers/Contacts/ContactListContainer'),
    loading: Loading,
});

export const ContactForm = Loadable({
    loader: () => import('../containers/Contacts/ContactEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesContacts.js